











 










const node = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "EditReflectionMutation_meeting",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "editorId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isEditing",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "promptId",
      "storageKey": null
    }
  ],
  "type": "EditReflectionPayload",
  "abstractKey": null
};

(node ).hash = "ae269d2fe2c90127cea821d1bda8a2d7";

export default node;
